<template>
  <div class="root">
    <!-- Insert an iframe occupying the full screen -->
    <div ref="root" class="root-content">
      <iframe
        ref="iframe"
        class="full-screen-iframe pt-6"
        frameborder="0"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        src="about:blank"
        title="Landing Page"
      ></iframe>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { get, error_message } from "@/utils";

export default {
  name: "HomeView",
  components: {},
  methods: {
    redirect() {
      const token = localStorage.getItem("session_token");
      if (token) this.$router.replace({ name: "home" });
      else this.$router.replace({ name: "login" });
    },
    get_settings() {
      return new Promise((resolve, reject) => {
        let v = this;
        v.$root.loader(true);
        get("/system/settings", {})
          .then((r) => {
            localStorage.setItem("system_settings", JSON.stringify(r));
            v.$root.loader(false);
            resolve(r);
          })
          .catch((err) => {
            console.error(err);
            v.$root.loader(false);
            reject(err);
          });
      });
    },
  },
  mounted() {
    let v = this;
    v.get_settings()
      .then((s) => {
        if (s && s.landing_settings) {
          if (s.landing_settings.replace_login) {
            if (s.landing_settings.default_page) {
              window.location.href = `/pages/${s.landing_settings.default_page}/`;
              // v.$router.replace({
              //   path: `/landing/page/${s.landing_settings.default_page}`,
              // });
            } else {
              console.log("No default page set, redirecting to login");
              v.redirect();
            }
            try {
              // console.log("Setting iframe content");
              // v.$refs.iframe.srcdoc = s.landing_settings.settings.message;
              // window.addEventListener("message", function (event) {
              //   if (event.data.type === "NAVIGATE_TO_LOGIN") {
              //     window.location.href = event.data.url;
              //   }
              // });
            } catch (error) {
              console.error("Error setting iframe content:", error);
            }
          } else {
            console.log("Landing settings do not replace login, redirecting");
            v.redirect();
          }
        } else {
          console.log("No landing settings found");
          v.redirect();
        }
      })
      .catch((err) => {
        error_message(err);
      });
  },
};
</script>

<style scoped>
.full-screen-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}
.root-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
